import {
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { Loader } from "@components/loader";
import { formatDate } from "@utils/format-utils";
import type { SmAiConversation } from "@hooks/use-sm-ai-chat/types";

export const ConversationList = ({
  conversations,
  isLoading,
  activeConversationId,
  onSelect,
}: {
  conversations: SmAiConversation[];
  isLoading: boolean;
  activeConversationId: string | null;
  onSelect: (id: string) => void;
}) => {
  if (isLoading) {
    return <Loader message="Loading conversations…" />;
  }

  if (conversations.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No conversations yet — start a new chat.
      </Typography>
    );
  }

  return (
    <List disablePadding>
      {conversations.map((conversation) => (
        <ListItemButton
          key={conversation.id}
          selected={conversation.id === activeConversationId}
          onClick={() => onSelect(conversation.id)}
          sx={{ borderRadius: 1, mb: 0.5 }}
        >
          <ListItemText
            primary={conversation.title || "Untitled conversation"}
            secondary={formatDate(conversation.updatedAt)}
            primaryTypographyProps={{ noWrap: true }}
          />
        </ListItemButton>
      ))}
    </List>
  );
};
